import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;
const DASHBOARD_ENDPOINT = '/dashboards/operational';

export const getOperationalDashboardSummary = async ({ startDate, endDate, dateFilterType, departmentIds } = {}) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (dateFilterType) params.dateFilterType = dateFilterType;
  if (Array.isArray(departmentIds) && departmentIds.length) {
    params.departmentIds = departmentIds.join(",");
  }

  const response = await axiosInstance.get(DASHBOARD_ENDPOINT, { params });
  return response.data;
};

export const getDashboardElements = async () => {
  const response = await axiosInstance.get(`${API_URL}/dashboard-elements`);
  return response.data;
};
